import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminTeamsService = {
  getTeams: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/admin/teams`, getAxiosOptions(user))).data
  },
  getTeamTypeAndSubTypes: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/admin/teams/get-team-type-subtype`, getAxiosOptions(user))).data
  },
  getUsers: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/user/user-detail/company`, getAxiosOptions(user)))
      .data
  },
  deleteUserFromTeam: async (user, userId, teamId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/user/user-team-map/delete/${userId}/${teamId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  addUserToTeam: async (user, userIds, teamId) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user/user-team-map/add`,
        { user_ids: userIds, team_id: teamId },
        getAxiosOptions(user)
      )
    ).data
  },
  addEditUser: async (user, payload) => {
    return (
      await axios.post(`${NODE_BASE_URL}/admin/user/add-edit`, payload, getAxiosOptions(user))
    ).data
  },
  addEditTeam: async (user, payload) => {
    return (
      await axios.post(`${NODE_BASE_URL}/admin/user/team/add-edit`, payload, getAxiosOptions(user))
    ).data
  },
  getDepartmentByCompanyId: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/user/user-detail/department`, getAxiosOptions(user)))
      .data
  },
  getDesignationByCompanyId: async (user) => {
    return (
      await axios.get(`${NODE_BASE_URL}/user/user-detail/designations`, getAxiosOptions(user))
    ).data
  },
  getUserTeamMapByCompanyId: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/user/user-detail/user-team-map/company`,
        getAxiosOptions(user)
      )
    ).data
  },
}
